import LogoBaseController from "./logo_base_controller.js";
import SiteBuilderLogoSaveController from "../site_builder/direct_logo_upload_save_controller";
import { memoizeFIFO } from "../helpers/memoize.js";

// Connects to data-controller="logo--direct-logo-upload"
export default class extends LogoBaseController {
  static targets = [
    "imageFileInputDropper",
    "imageFileInput",
    "dropSection",
    "cropSection",
    "croppedImage",
    "cropperImageContainer",
    "loader",
    "errorMessage",
    "filename"
  ];

  static values = {
    permittedFormats: String,
    fromSiteBuilder: Boolean,
  };

  initialize() {
    super.initialize();
    this.cropperSection = $(this.cropSectionTarget);
    this.cropperImageContainer = this.cropperSection.find(
      ".media__cropper-image-container"
    );
    this.imageFileInputTarget.title = "";
    this.imageFileInputDropperTarget.title = "";
    this.urlToBase64Store = memoizeFIFO(this.fetchImageAsBase64, { size: 3 });
  }

  handleClick(e) {
    if (e.target.id === "logo-input-dropper") {
      e.preventDefault();
    }
  }

  addFile(e) {
    this.uploadedFile = e.target.files[0];
    this.handleAddFile(e, this.initializeLogoCropper.bind(this));
  }

  cancel() {
    this.goBack(this.cropSectionTarget, this.dropSectionTarget);
    this.imageFileInputTarget.value = "";
    this.imageFileInputDropperTarget.value = "";
    if (this.fileUploadCropper) {
      this.fileUploadCropper.reset_zoom_slider();
    }
  }

  save() {
    if (this.fromSiteBuilderValue) {
      this.saveSiteBuilderLogo();
    } else {
      this.saveCmsAppearanceLogo();
    }
  }

  saveSiteBuilderLogo() {
    this.persistLogoCropperState({
      containerSelector: '.brand-logo',
      cropperInstance: this.fileUploadCropper,
      imageUrl: this.uploadedFile ? URL.createObjectURL(this.uploadedFile) : '',
      imageName: this.getImageName(),
    });

    const hasCropped = this.fileUploadCropper?.hasChanged?.() ?? false;

    if (!hasCropped && !this.uploadedFile) {
      const modal = document.querySelector(".modal");
      if (modal && modal.close) {
        modal.close();
      } else if (window.modal && window.modal.close) {
        window.modal.close();
      }
      this.dispatch("image_saved");
      return;
    }

    SiteBuilderLogoSaveController.save(
      this.fileUploadCropper,
      this.uploadedFile,
      this.application
    );
    this.dispatch("image_saved");
  }

  saveCmsAppearanceLogo() {
    this.persistLogoCropperState({
      containerSelector: '.site-logo-images',
      cropperInstance: this.fileUploadCropper,
      imageUrl: this.uploadedFile ? URL.createObjectURL(this.uploadedFile) : '',
      imageName: this.getImageName(),
    });

    const hasCropped = this.fileUploadCropper?.hasChanged?.() ?? false;

    if (hasCropped) {
      this.applyLogoFromCropper(this.fileUploadCropper, this.getImageName());
    } else if (this.uploadedFile) {
      this.applyLogoFromImage(this.uploadedFile, this.getImageName());
    } else {
      this.showProcessingLoader();
      window.modal.close();
      $(".logo-image-section-loading").fadeOut("fast");
      $(".site-logo-images").animate({ opacity: 1 }, "fast");
      return;
    }
    this.showProcessingLoader();
  }

  getImageName() {
    return (
      this.uploadedFile?.name ||
      (this.hasFilenameTarget && this.filenameTarget.textContent?.trim()) ||
      document.querySelector('.logo-cropper-details')?.getAttribute('data-original-image-name') ||
      this.imageFileInputTarget?.files?.[0]?.name ||
      this.imageFileInputDropperTarget?.files?.[0]?.name ||
      ''
    );
  }

  isValidFileType(fileType) {
    // Handle special cases for SVG and ICO files
    let format;
    switch (fileType) {
      case "image/svg+xml":
        format = "svg";
        break;
      case "image/vnd.microsoft.icon":
      case "image/x-icon":
        format = "ico";
        break;
      default:
        format = fileType.split("/")[1];
    }

    return this.permittedFormatsValue.includes(format);
  }

  async fetchImageAsBase64(url) {
    const data = await fetch(url, { headers: { "Cache-Control": "no-cache" } });
    const blob = await data.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
    });
  }
}
